/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SectionSearchOrderBy {
    SectionCode = 'SectionCode',
    Roles = 'Roles',
    Permissions = 'Permissions'
}


export function instanceOfSectionSearchOrderBy(value: any): boolean {
    for (const key in SectionSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(SectionSearchOrderBy, key)) {
            if (SectionSearchOrderBy[key as keyof typeof SectionSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SectionSearchOrderByFromJSON(json: any): SectionSearchOrderBy {
    return SectionSearchOrderByFromJSONTyped(json, false);
}

export function SectionSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionSearchOrderBy {
    return json as SectionSearchOrderBy;
}

export function SectionSearchOrderByToJSON(value?: SectionSearchOrderBy | null): any {
    return value as any;
}

export function SectionSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): SectionSearchOrderBy {
    return value as SectionSearchOrderBy;
}

